/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_TariffRateRequest } from './billing_TariffRateRequest';
export type billing_UpdateTariffVersionRequest = {
    /**
     * AgeTransitionMonths to update (nil => unchanged)
     */
    age_transition_months?: number;
    /**
     * AgeTransitionMonthsSubsidised to update (nil => unchanged)
     */
    age_transition_months_subsidised?: number;
    /**
     * AgeTransitionTiming to update (nil => unchanged)
     */
    age_transition_timing?: billing_UpdateTariffVersionRequest.age_transition_timing;
    /**
     * Description to update
     */
    description?: string;
    /**
     * IsDefault flag to update
     */
    is_default?: boolean;
    /**
     * Name to update
     */
    name?: string;
    /**
     * Rates to update (optional, if provided will update existing rates)
     */
    rates?: Array<billing_TariffRateRequest>;
    /**
     * RoundingParentsAmount to update, step in Rappen (>=1) (nil => unchanged)
     */
    rounding_parents_amount?: number;
    /**
     * RoundingParentsEnabled to update (nil => unchanged)
     */
    rounding_parents_enabled?: boolean;
    /**
     * RoundingSubsidyAmount to update, step in Rappen (>=1) (nil => unchanged)
     */
    rounding_subsidy_amount?: number;
    /**
     * RoundingSubsidyEnabled to update (nil => unchanged)
     */
    rounding_subsidy_enabled?: boolean;
    /**
     * Status to update (DRAFT, ACTIVE, EXPIRED, ARCHIVED)
     */
    status?: billing_UpdateTariffVersionRequest.status;
};
export namespace billing_UpdateTariffVersionRequest {
    /**
     * AgeTransitionTiming to update (nil => unchanged)
     */
    export enum age_transition_timing {
        FOLLOWING_MONTH = 'FOLLOWING_MONTH',
        ON_BIRTHDAY = 'ON_BIRTHDAY',
    }
    /**
     * Status to update (DRAFT, ACTIVE, EXPIRED, ARCHIVED)
     */
    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        EXPIRED = 'EXPIRED',
        ARCHIVED = 'ARCHIVED',
    }
}

